var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 2.29498H45.72V25.14H48V2.29498Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.72 0H20.58V2.295H45.72V0Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.72 25.14H36.585V27.435H45.72V25.14Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.865 16.005H36.585V20.58H38.865V16.005Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.865 9.15002H36.585V11.43H38.865V9.15002Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.585 27.435H34.29V29.715H36.585V27.435Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.29 29.715H32.01V32.01H34.29V29.715Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.01 22.86V25.14H34.29V22.86H36.585V20.58H34.29V16.005H36.585V13.71H34.29V9.15001H36.585V6.85501H34.29V4.57501H32.01V6.85501H29.715V9.15001H32.01V13.71H29.715V16.005H32.01V20.58H29.715V22.86H32.01Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.435 27.435H25.155V34.29H32.01V32.01H27.435V27.435Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7151 18.285H27.4351V20.58H29.7151V18.285Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7151 9.15002H27.4351V13.71H29.7151V9.15002Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.435 45.72H22.86V48H27.435V45.72Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.86 43.425H18.285V45.72H22.86V43.425Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.58 38.865H18.285V41.145H20.58V38.865Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.58 2.29498H18.285V16.005H20.58V2.29498Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87 41.145V43.425H11.43V48H13.725V43.425H18.285V41.145H6.87Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.285 34.29H16.005V36.57H18.285V34.29Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.285 29.715H16.005V32.01H18.285V29.715Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0051 36.57H11.4301V38.865H16.0051V36.57Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15 29.715H6.87V32.01H9.15V29.715Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86995 38.865H4.57495V41.145H6.86995V38.865Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87004 43.425H2.29504V45.72H6.87004V43.425Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57504 27.435H6.87004V25.14H18.285V27.435H20.58V38.865H22.86V22.86H20.58V20.58H18.285V18.285H6.87004V20.58H4.57504V22.86H2.29504V38.865H4.57504V27.435Z",
    fill: "#474350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.295 45.72H0V48H2.295V45.72Z",
    fill: "#474350"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkIcon);
export default __webpack_public_path__ + "static/media/work_icon.d3563a9cfd48e876cb4093d8cf1e4c4d.svg";
export { ForwardRef as ReactComponent };